import { render, staticRenderFns } from "./TemporaryReferral.vue?vue&type=template&id=bc045352"
import script from "./TemporaryReferral.vue?vue&type=script&lang=js"
export * from "./TemporaryReferral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports